import { memo } from "react";

import { tw } from "classnames";

const styles = {
  base: tw("flex", "gap-2", "h-4", "items-center"),
  item: tw("h-2", "rounded-full", "bg-placeholder", "animate-pulse"),
};

const BreadcrumbsPlaceholderBase = () => {
  return (
    <div className={styles.base}>
      <div className={tw(styles.item, "w-7")}></div>
      <div className={tw(styles.item, "w-18")}></div>
      <div className={tw(styles.item, "w-14")}></div>
    </div>
  );
};

export const BreadcrumbsPlaceholder = memo(BreadcrumbsPlaceholderBase);
